import {Nullable} from '../../../../../app/TypeHelpers'
import moment from 'moment'
import {convertToNullableMoment} from '../../../../../components/reservations/helpers/helpers'

export const getFormattedDate = (
    date: string
): string => {
    const dateMoment: Nullable<moment.Moment> = convertToNullableMoment(date, null)
    return (dateMoment) ? dateMoment.format('YYYY年M月D日') : ''
}